enum TeamFieldNames {
  Accesses = 'accesses',
  Color = 'color',
  Description = 'description',
  Name = 'name',
  Users = 'users',
  UsersList = 'usersList',
  DetailsTitle = 'details-title',
  MembersAssignationTitle = 'members-assignation-title',
  MembersAssignationMessage = 'members-assignation-message',
  TeamAccessesMessage = 'team-accesses-message',
  TeamAccessRights = 'team-access-rights',
}

export default TeamFieldNames;
